/* eslint-disable no-useless-constructor */
import { Controller, Menu } from '@tencent/workbench';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { MenuKey } from '../../schema/menu-schema/common';
import { MENU_CONFIGS } from './config';
import LocalFileSaveAsFeature from './save-as-feature';
import { PPTEditorStateEnumType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';

@Controller({ menuItems: MENU_CONFIGS })
export class LocalFileSaveAsController {
    constructor(private readonly feature: LocalFileSaveAsFeature) {
    }

    @Menu(MenuKey.LOCAL_FILE_SAVE_AS, 'onClick')
    public handleFileSaveAs(): void {
        this.feature.handleClickSaveAs();
    }

    @Menu(MenuKey.LOCAL_FILE_SAVE, 'onClick')
    public handleFileSave(): void {
        this.feature.handleClickSave();
    }

    @Menu(MenuKey.LOCAL_FILE_SAVE_AS, 'shouldHide')
    public hideLocalSaveAs(): boolean {
        return !DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.localFileSaveAs);
    }

    @Menu(MenuKey.LOCAL_FILE_SAVE, 'shouldHide')
    public hideLocalSave(): boolean {
        return !DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.localFileSave);
    }

    @Menu(MenuKey.LOCAL_FILE_SAVE, 'shouldDisabled')
    public disabledLocalSave(): boolean {
        // 本地有加密弹框的时候存在只读态
        const { pptEditorState } = this.getAppService().viewableServiceLayer.userPriviledgeService;
        return pptEditorState !== PPTEditorStateEnumType.EDITABLE;
    }

    private getAppService(): IPcEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }
}
